import styled from 'styled-components';

export const MainContainer = styled.div`
  display: flex;
  justify-content: space-between;

  & > div:last-child {
    align-self: flex-end;
    display: flex;
    cursor: pointer;
    margin-bottom: 14px;
    & > div:first-child {
      margin-right: 20px;
    }
  }
`;

export const InfoBlock = styled.div`
  display: flex;
  margin-bottom: 14px;

  & > div:first-child {
    margin-right: 8px;
  }
`;
